import { Injectable } from '@angular/core';
import {ColumnApi, GridApi, RowNode} from 'ag-grid-community';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {BehaviorSubject, Observable, of, Subject, switchMap} from 'rxjs';
import { HttpService } from './http.service';
import { deepmerge } from 'deepmerge-ts';
import {tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GridService {
  public aiTagsGridApi?: GridApi;

  public gridApi?: GridApi;
  public columnApi?: ColumnApi;

  public changesGridApi?: GridApi;
  public changesColumnApi?: ColumnApi;

  public historyGridApi?: GridApi;
  public historyColumnApi?: ColumnApi;

  public productionGridApi?: GridApi;
  public productionColumnApi?: ColumnApi;

  public changedItemsCount: Observable<any> | undefined;
  private changedItemsCountSubject: BehaviorSubject<any> | undefined;

  public changedItemsLogsCount: Observable<any> | undefined;
  private changedItemsLogsCountSubject: BehaviorSubject<any> | undefined;

  public availableRam$: BehaviorSubject<any> = new BehaviorSubject<any>(0);
  public systemStats$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public presence$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  public historyConflictCounter$: BehaviorSubject<any> = new BehaviorSubject<any>(0);
  public historyApprovedCounter$: BehaviorSubject<any> = new BehaviorSubject<any>(0);
  public historyChangesCounter$: BehaviorSubject<any> = new BehaviorSubject<any>(0);
  public disapproveCounter$: BehaviorSubject<any> = new BehaviorSubject<any>(0);
  public productionChangesCounter$: BehaviorSubject<any> = new BehaviorSubject<any>(0);
  public stageChangesCounter$: BehaviorSubject<any> = new BehaviorSubject<any>(0);

  public stageSelectedItemsCount$: BehaviorSubject<any> = new BehaviorSubject<any>(0);
  public productionSelectedItemsCount$: BehaviorSubject<any> = new BehaviorSubject<any>(0);
  public changesSelectedItemsCount$: BehaviorSubject<any> = new BehaviorSubject<any>(0);
  public historySelectedItemsCount$: BehaviorSubject<any> = new BehaviorSubject<any>(0);

  public stageFilterIsActive$: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public productionFilterIsActive$: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public changesFilterIsActive$: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public historyFilterIsActive$: BehaviorSubject<any> = new BehaviorSubject<any>(false);

  public aiGrid1Ready$: BehaviorSubject<any> = new BehaviorSubject<any>(true);
  public aiUpdateResultsTable$: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public aiGptParser$: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public aiCompleteJob$: BehaviorSubject<any> = new BehaviorSubject<any>(false);

  public aiTreeSelectProject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public aiTreeSelectLevel: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public aiTreeChangeFilter: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public aiTreeGridEvent: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  public aiLearGridEvent: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public aiFineTuneGptCompleteEvent: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public aiFineTuneGptCompleteAllEvent: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  private refreshTableTimer: any = null;
  constructor(
    private http: HttpClient,
    private httpService: HttpService
  ) {
    this.changedItemsCountSubject = new BehaviorSubject<any>(0);
    this.changedItemsCount = this.changedItemsCountSubject.asObservable();

    this.changedItemsLogsCountSubject = new BehaviorSubject<any>(0);
    this.changedItemsLogsCount = this.changedItemsLogsCountSubject.asObservable();

    // this.getChangesItems();
    // this.getChangesItemsFromLogs();
  }

  public refreshMetadataCells(): void {
    this.gridApi?.refreshCells({ force: true });
    this.productionGridApi?.refreshCells({ force: true });
    this.changesGridApi?.refreshCells({ force: true });
    this.historyGridApi?.refreshCells({ force: true });
  }

  public refreshChangesGrid(): void {
    this.changesGridApi?.refreshServerSide();
    // this.updateChangesHistoryCount();
    // this.updateConflictsHistoryCount();
  }

  public logRowUpdate(payload: any): any {
    this.changesGridApi?.forEachNode((rowNode: RowNode) => {
      if (rowNode.data && rowNode.data.id === payload.id) {
        // const rowData = {...rowNode.data, ...payload};
        const rowData = deepmerge(rowNode.data, payload);
        console.log('deepmerge', rowData);
        rowNode.setData(rowData);
      }
    });
  }

  public stageLockProductsRowUpdate(payload: any): any {
    if (this.checkActiveGrid(this.gridApi)) {
      this.gridApi?.forEachNode((rowNode: RowNode) => {
        if (rowNode.data && payload.locked.user._id) {
          if (payload.products.includes(rowNode.data._id)) {
            const rowData = {...rowNode.data, ...{locked: payload.locked}};
            rowNode.setData(rowData);
          }
        }
      });
    }
  }

  public stageUnlockProductsRowUpdate(payload: any): any {
    if (this.checkActiveGrid(this.gridApi)) {
      this.gridApi?.forEachNode((rowNode: RowNode) => {
        if (rowNode.data && rowNode.data.locked && rowNode.data.locked?.user?._id === payload.user_id) {
          // const rowData = {...rowNode.data, ...{locked: {}}};
          const rowData = rowNode.data;
          delete rowData.locked;
          rowNode.setData(rowData);
        }
      });
    }
    if (this.checkActiveGrid(this.changesGridApi)) {
      this.changesGridApi?.forEachNode((rowNode: RowNode) => {
        if (rowNode.data && rowNode.data.locked && rowNode.data.locked?.user?._id === payload.user_id) {
          // const rowData = {...rowNode.data, ...{locked: {}}};
          const rowData = rowNode.data;
          delete rowData.locked;
          rowNode.setData(rowData);
        }
      });
    }
  }

  // Track when we need to refresh after sync status updates
  private pendingRefreshTimer: any;
  private needsServerRefresh: boolean = false;

  public productionRowUpdate(payload: any): any {
    if (this.checkActiveGrid(this.productionGridApi)) {
      let foundRow = false;
      this.productionGridApi?.forEachNode((rowNode: RowNode) => {
        if (rowNode.data && rowNode.data._id === payload._id) {
          foundRow = true;
          if (payload.tags) {
            rowNode.data.tags = {}
          }
          if (payload.vendor_tags) {
            rowNode.data.vendor_tags = {}
          }
          if (payload.related_products) {
            rowNode.data.related_products = {};
          }
          if (payload.related_parts) {
            rowNode.data.related_parts = {};
          }
          if (payload.related_collections) {
            rowNode.data.related_collections = '';
          }
          if (payload.datasheet_new) {
            rowNode.data.datasheet_new = [];
          }
          if (payload.replacement && payload.replacement.obsolete === false) {
            delete rowNode.data.replacement;
          }
          // const rowData = payload.tags ? {...rowNode.data, ...payload} : deepmerge(rowNode.data, payload);
          const rowData = deepmerge(rowNode.data, payload);
          rowNode.setData(rowData);

          // CRITICAL FIX: Force immediate visual refresh for status updates
          // This prevents "Pending Sync" from persisting after successful sync
          if (payload.status !== undefined) {
            // Immediately refresh the status cell for instant visual feedback
            this.productionGridApi?.refreshCells({
              rowNodes: [rowNode],
              columns: ['status'],
              force: true
            });
          }

          // CRITICAL FIX: If status is being updated (sync completion), schedule a server refresh
          // This prevents "Pending Sync" from persisting after successful sync
          if (payload.status !== undefined &&
              (payload.status === 10 || payload.status === 80) &&
              rowNode.data.status === 60) {
            this.needsServerRefresh = true;
          }
        }
      });

      // If we found the row and it's a sync status update, refresh server-side data
      // Use debouncing to batch multiple updates together
      if (foundRow && this.needsServerRefresh) {
        clearTimeout(this.pendingRefreshTimer);
        this.pendingRefreshTimer = setTimeout(() => {
          // Skip refresh if user is editing to prevent focus loss
          if (this.isAnyGridEditing()) {
            console.log('Skipping productionRowUpdate refresh - grid is being edited');
            return;
          }
          if (this.checkActiveGrid(this.productionGridApi)) {
            // Refresh without purging to maintain view state
            this.productionGridApi?.refreshServerSide();
            this.needsServerRefresh = false;
          }
        }, 500); // Small delay to batch multiple status updates
      }
    }
  }

  private checkActiveGrid(gridApi: any): boolean {
    return !!(gridApi && gridApi.destroyCalled === false);
  }

  /**
   * Check if a specific grid is currently in edit mode
   * @param gridApi The grid API to check
   * @returns true if the grid is currently editing a cell
   */
  public isGridEditing(gridApi: GridApi | undefined): boolean {
    if (!gridApi) return false;
    try {
      const editingCells = gridApi.getEditingCells();
      return editingCells && editingCells.length > 0;
    } catch (e) {
      // Grid may be destroyed, return false
      return false;
    }
  }

  /**
   * Check if ANY grid is currently in edit mode
   * Used to prevent refreshes from interrupting user editing
   * @returns true if any grid is currently being edited
   */
  public isAnyGridEditing(): boolean {
    return this.isGridEditing(this.gridApi) ||
           this.isGridEditing(this.productionGridApi) ||
           this.isGridEditing(this.changesGridApi) ||
           this.isGridEditing(this.historyGridApi);
  }

  public rowUpdate(payload: any, args: any = ''): any {

    if (this.checkActiveGrid(this.gridApi)) {
      // console.log('----', payload);
      this.gridApi?.forEachNode((rowNode: RowNode) => {
        if (rowNode.data && rowNode.data._id === payload._id) {
          // const changes = payload.changes === null ? {} : payload.changes;
          if (payload.replacement && payload.replacement.obsolete === false) {
            delete rowNode.data.replacement;
          }
          if (args.split(',').includes('unlock')) {
            delete rowNode.data.locked;
          }
          if (payload.tags) {
            rowNode.data.tags = {}
          }
          if (payload.vendor_tags) {
            rowNode.data.vendor_tags = {}
          }
          if (payload.related_products) {
            rowNode.data.related_products = {};
          }
          if (payload.related_parts) {
            rowNode.data.related_parts = {};
          }
          if (payload.related_collections) {
            rowNode.data.related_collections = '';
          }
          if (payload.datasheet_new) {
            rowNode.data.datasheet_new = [];
          }
          if (payload.collections) {
            rowNode.data.collections = [];
          }
          // const rowData = payload.tags ? {...rowNode.data, ...payload} : deepmerge(rowNode.data, payload);
          const rowData = deepmerge(rowNode.data, payload);
          console.log('rowData', rowData);
          rowNode.setData(rowData);
        }
      });
    }
    if (this.checkActiveGrid(this.changesGridApi)) {
      clearTimeout(this.refreshTableTimer);
      this.refreshTableTimer = setTimeout(() => {
        // Skip refresh if user is editing to prevent focus loss
        if (this.isAnyGridEditing()) {
          console.log('Skipping rowUpdate changesGrid refresh - grid is being edited');
          return;
        }
        this.changesGridApi?.refreshServerSide();
      }, 1000);

      this.changesGridApi?.forEachNode((rowNode: RowNode) => {
        if (rowNode.data && rowNode.data._id === payload._id) {
          // const changes = payload.changes === null ? {} : payload.changes;
          if (args.split(',').includes('unlock')) {
            delete rowNode.data.locked;
          }
          if (payload.tags) {
            rowNode.data.tags = {}
          }
          if (payload.vendor_tags) {
            rowNode.data.vendor_tags = {}
          }
          // const rowData = payload.tags ? {...rowNode.data, ...payload} : deepmerge(rowNode.data, payload);
          const rowData = deepmerge(rowNode.data, payload);
          rowNode.setData(rowData);
        }
      });
    }
  }
  // public updateChangesHistoryCount(): void {
  //   this.fetchChangesHistoryCount();
  // }

  // public updateConflictsHistoryCount(): void {
  //   this.fetchConflictsHistoryCount();
  // }
  public getChangesStageCount(): any {
    return this.historyChangesCounter$.pipe(switchMap((count: any) => {
      // console.log('count', count);
      if (count) {
        return of(count);
      }
      return of(null);
      // return this.fetchChangesHistoryCount();
    }));
  }

  public getAvailableRam(): any {
    return this.availableRam$.pipe(switchMap((count: any) => {
      if (count) {
        return of(count);
      }
      return of(null);
      // return this.fetchChangesHistoryCount();
    }));
  }

  public getSystemStats(): any {
    return this.systemStats$.asObservable();
  }

  public getPresence(): any {
    return this.presence$.asObservable();
  }

  public getChangesHistoryCount(): any {
    return this.historyChangesCounter$.pipe(switchMap((count: any) => {
      // console.log('count', count);
      if (count) {
        return of(count);
      }
      return of(null);
      // return this.fetchChangesHistoryCount();
    }));
  }

  public getDisapproveCount(): any {
    return this.disapproveCounter$.pipe(switchMap((count: any) => {
      // console.log('count', count);
      if (count) {
        return of(count);
      }
      return of(null);
      // return this.fetchChangesHistoryCount();
    }));
  }

  public getProductionChangesCount(): any {
    return this.productionChangesCounter$.pipe(switchMap((count: any) => {
      // console.log('count', count);
      if (count) {
        return of(count);
      }
      return of(null);
      // return this.fetchChangesHistoryCount();
    }));
  }

  public getConflictsHistoryCount(): any {
    return this.historyConflictCounter$.pipe(switchMap((count: any) => {
      if (count) {
        return of(count);
      }
      return of(null);
    }));
  }

  public getApprovedHistoryCount(): any {
    return this.historyApprovedCounter$.pipe(switchMap((count: any) => {
      if (count) {
        return of(count);
      }
      return of(null);
    }));
  }

  // private fetchChangesHistoryCount(): any {
  //   return this.httpService.get(environment.API_PATH + '/log/counter')
  //     .pipe(tap((data: any) => {
  //       this.historyChangesCounter$.next(data.confirm.length);
  //       // this.historyConflictCounter$.next(data.conflicts.length);
  //     })).subscribe();
  // }

  // private fetchConflictsHistoryCount(): any {
  //   return this.httpService.get(environment.API_PATH + '/log/counter')
  //     .pipe(tap((data: any) => {
  //       // this.historyChangesCounter$.next(data.confirm.length);
  //       this.historyConflictCounter$.next(data.conflicts.length);
  //     })).subscribe();
  // }

  // public getChangesItems(): void {
  //   this.httpService.get(environment.API_PATH + '/product/all-changes').subscribe((res: any) => {
  //     this.changedItemsCountSubject?.next(res.length)
  //   });
  // }
  //
  // public getChangesItemsFromLogs(): void {
  //   this.httpService.get(environment.API_PATH + '/product/all-changes-logs').subscribe((res: any) => {
  //     this.changedItemsLogsCountSubject?.next(res)
  //   });
  // }
}
